(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snowbeast-announcement"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('snowbeast-daily-countdown')){
    customElements.define('snowbeast-daily-countdown',class extends HTMLElement{
      connectedCallback(){
        this.stop();
        this.formatter=new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Bucharest',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
        this.clock=this.querySelector('.sb-daily__clock');
        this.hours=this.querySelector('[data-hours]');this.minutes=this.querySelector('[data-minutes]');this.seconds=this.querySelector('[data-seconds]');
        if(!this.clock||!this.hours||!this.minutes||!this.seconds)return;
        this.abort=new AbortController();
        document.addEventListener('visibilitychange',()=>this.tick(),{signal:this.abort.signal});
        this.tick();
      }
      parts(date){return Object.fromEntries(this.formatter.formatToParts(date).filter(p=>p.type!=='literal').map(p=>[p.type,Number(p.value)]));}
      nextMidnight(now){
        const local=this.parts(now);
        const target=Date.UTC(local.year,local.month-1,local.day+1);
        let instant=target;
        for(let i=0;i<3;i++){
          const p=this.parts(new Date(instant));
          const offset=Date.UTC(p.year,p.month-1,p.day,p.hour,p.minute,p.second)-instant;
          instant=target-offset;
        }
        return instant;
      }
      tick(){
        clearTimeout(this.timeout);
        const now=new Date();
        const remaining=Math.max(0,Math.ceil((this.nextMidnight(now)-now.getTime())/1000));
        const values=[Math.floor(remaining/3600),Math.floor(remaining%3600/60),remaining%60];
        [this.hours,this.minutes,this.seconds].forEach((node,i)=>{const value=String(values[i]).padStart(2,'0');if(node.textContent!==value)node.textContent=value;});
        this.clock.hidden=false;
        if(this.isConnected)this.timeout=setTimeout(()=>this.tick(),1000-now.getMilliseconds());
      }
      stop(){clearTimeout(this.timeout);this.abort?.abort();}
      disconnectedCallback(){this.stop();}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snowbeast-choose"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('snowbeast-choose')) {
    customElements.define('snowbeast-choose', class extends HTMLElement {
      connectedCallback() { queueMicrotask(() => { if (this.isConnected) this.initialize(); }); }
      initialize() {
        this.abort?.abort();
        this.abort = new AbortController();
        this.addEventListener('change', event => {
          if (event.target.matches('.sb-choose__radio')) this.select(event.target);
        }, { signal: this.abort.signal });
        const selected = this.querySelector('.sb-choose__radio:checked');
        if (selected) this.select(selected);
      }
      disconnectedCallback() { this.abort?.abort(); }
      select(input) {
        const available = input.dataset.available === 'true';
        const image = this.querySelector('.sb-choose__main-image');
        if (image && input.dataset.image) {
          image.removeAttribute('srcset');
          image.src = input.dataset.image;
          image.alt = input.dataset.title;
        }
        this.querySelector('.sb-choose__name').textContent = input.dataset.title;
        this.querySelector('.sb-choose__price').textContent = input.dataset.price;
        const compare = this.querySelector('.sb-choose__compare');
        compare.textContent = input.dataset.compare;
        compare.hidden = input.dataset.sale !== 'true';
        const button = this.querySelector('.sb-choose__add');
        button.disabled = !available;
        this.querySelector('.sb-choose__add-label').textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
        const stock = this.querySelector('.sb-choose__stock');
        this.querySelector('.sb-choose__stock-text').textContent = available ? stock.dataset.inStock : stock.dataset.outOfStock;
        this.toggleAttribute('data-unavailable', !available);
        this.querySelector('.sb-choose__details').href = input.dataset.url;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snowbeast-descent"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('snowbeast-descent')) {
    customElements.define('snowbeast-descent', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => { if (this.isConnected) this.initialize(); });
      }
      initialize() {
        this.abort?.abort();
        this.abort = new AbortController();
        this.rider = this.querySelector('.sb-descent__rider');
        this.route = this.querySelector('.sb-descent__route');
        this.trail = this.querySelector('.sb-descent__trail');
        this.status = this.querySelector('.sb-descent__status');
        if (!this.rider || !this.route || !this.trail || !this.status) return;
        this.length = this.route.getTotalLength();
        this.trail.style.strokeDasharray = this.length;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.progress = 0;
        this.queueUpdate = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
        };
        window.addEventListener('scroll', this.queueUpdate, { passive: true, signal: this.abort.signal });
        window.addEventListener('resize', this.queueUpdate, { passive: true, signal: this.abort.signal });
        this.motion.addEventListener('change', this.queueUpdate, { signal: this.abort.signal });
        this.observer = new ResizeObserver(this.queueUpdate);
        this.observer.observe(this);
        this.update();
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        clearTimeout(this.idleTimer);
        this.abort?.abort();
        this.observer?.disconnect();
        this.frame = 0;
      }
      update() {
        if (!this.isConnected || !this.route) return;
        const rect = this.getBoundingClientRect();
        const start = innerHeight * .35;
        const span = start + rect.height * .55;
        const progress = this.motion.matches ? 0 : Math.max(0, Math.min(1, (start - rect.top) / span));
        const distance = progress * this.length;
        const point = this.route.getPointAtLength(distance);
        const moved = Math.abs(progress - this.progress) > .0001;
        const ahead = this.route.getPointAtLength(Math.min(this.length, distance + 12));
        const lean = moved && progress > 0 && progress < 1 ? Math.max(-24, Math.min(24, (ahead.x - point.x) * 1.8)) : 0;
        this.rider.style.left = `${point.x / 12}%`;
        this.rider.style.top = `${point.y / 7.5}%`;
        this.rider.style.setProperty('--sb-lean', `${lean}deg`);
        this.trail.style.strokeDashoffset = this.length - distance;
        this.progress = progress;
        this.status.textContent = progress >= 1 ? this.status.dataset.done : progress > 0 ? this.status.dataset.going : this.status.dataset.ready;
        clearTimeout(this.idleTimer);
        this.toggleAttribute('data-running', moved && progress > 0 && progress < 1);
        if (this.hasAttribute('data-running')) {
          this.idleTimer = setTimeout(() => {
            this.removeAttribute('data-running');
            this.rider.style.setProperty('--sb-lean', '0deg');
          }, 120);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snowbeast-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('snowbeast-product')) {
    customElements.define('snowbeast-product', class extends HTMLElement {
      connectedCallback() { queueMicrotask(() => { if (this.isConnected) this.initialize(); }); }
      initialize() {
        this.abort?.abort();
        this.abort = new AbortController();
        this.stickyObserver?.disconnect();
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.updateSticky = () => {
          const mainButton = this.querySelector('.sb-product__add');
          const sticky = this.querySelector('.sb-product__sticky');
          if (!mainButton || !sticky) return;
          const typing = /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement?.tagName || '');
          sticky.hidden = !this.mobileQuery.matches || mainButton.getBoundingClientRect().bottom > 0 || typing;
        };
        this.stickyObserver = new IntersectionObserver(this.updateSticky, { threshold: [0, 1] });
        this.stickyObserver.observe(this.querySelector('.sb-product__add'));
        this.mobileQuery.addEventListener('change', this.updateSticky, { signal: this.abort.signal });
        window.addEventListener('resize', this.updateSticky, { signal: this.abort.signal, passive: true });
        document.addEventListener('focusin', this.updateSticky, { signal: this.abort.signal });
        document.addEventListener('focusout', () => requestAnimationFrame(this.updateSticky), { signal: this.abort.signal });
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-photo]');
          if (!button || !this.contains(button)) return;
          this.dataset.photoMode = button.dataset.photo;
          this.querySelectorAll('[data-photo]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          this.renderPhoto();
        }, { signal: this.abort.signal });
        this.addEventListener('change', event => {
          if (event.target.matches('.sb-product__radio')) this.select(event.target);
        }, { signal: this.abort.signal });
        const selected = this.querySelector('.sb-product__radio:checked');
        if (selected) this.select(selected);
        this.updateSticky();
      }
      disconnectedCallback() { this.abort?.abort(); this.stickyObserver?.disconnect(); }
      select(input) {
        const available = input.dataset.available === 'true';
        this.selectedInput = input;
        this.renderPhoto();
        this.querySelector('.sb-product__name').textContent = input.dataset.title;
        this.querySelector('.sb-product__price').textContent = input.dataset.price;
        const compare = this.querySelector('.sb-product__compare');
        compare.textContent = input.dataset.compare;
        compare.hidden = input.dataset.sale !== 'true';
        const button = this.querySelector('.sb-product__add');
        button.disabled = !available;
        this.querySelector('.sb-product__add-label').textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
        this.querySelector('.sb-product__sticky-name').textContent = input.dataset.title;
        this.querySelector('.sb-product__sticky-price').textContent = input.dataset.price;
        this.querySelector('.sb-product__sticky-add').disabled = !available;
        this.querySelector('.sb-product__sticky-label').textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
        const stock = this.querySelector('.sb-product__stock');
        this.querySelector('.sb-product__stock-text').textContent = available ? stock.dataset.inStock : stock.dataset.outOfStock;
        this.toggleAttribute('data-unavailable', !available);
        const url = new URL(location.href);
        url.searchParams.set('variant', input.value);
        history.replaceState(history.state, '', url);
      }
      renderPhoto() {
        const input = this.selectedInput;
        const image = this.querySelector('.sb-product__main-image');
        if (!input || !image) return;
        const source = this.dataset.photoMode === 'product' ? input.dataset.productImage : input.dataset.image;
        if (!source) return;
        image.removeAttribute('srcset');
        image.src = source;
        image.alt = input.dataset.title;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
